import { h } from "preact";

import { MenuButtonAsMenuItem } from "../MenuButton";
import Submenu from "../Submenu";
import withMenuItem, { WithMenuItemProps } from "../withMenuItem";

import "../style.css";

interface Props extends WithMenuItemProps {
    class?: string;
    checkedValue: string;
    options: {
        content: string;
        value: string;
        disabled?: boolean;
    }[];
    onChange?: (itemValue: string) => void;
}

function SingleSelectSubmenu({
    class: cssClass,
    checkedValue,
    content,
    open,
    highlighted,
    disabled,
    options,
    indicesPath,
    onChange,
    handleMenuChildClick,
    onMenuItemMouseEnter,
    handleMenuChildMouseEnter,
    onMenuItemMouseMove,
    handleMenuChildMouseMove
}: Props) {
    function handleItemClick(event: Event, itemValue?: string) {
        onChange?.(itemValue!);
        handleMenuChildClick?.(event, itemValue);
    }

    function getSubmenuContent() {
        let submenuContent;

        if (content) {
            const displayValue = options.find(option => option.value === checkedValue)!.content;

            submenuContent = `${content} (${displayValue})`;
        }

        return submenuContent;
    }

    return (
        <Submenu
            content={getSubmenuContent()}
            indicesPath={indicesPath}
            highlighted={highlighted}
            open={open}
            disabled={disabled}
            handleMenuChildMouseEnter={handleMenuChildMouseEnter}
            handleMenuChildMouseMove={handleMenuChildMouseMove}
            onMenuItemMouseEnter={onMenuItemMouseEnter}
            onMenuItemMouseMove={onMenuItemMouseMove}>
            {options.map(option => (
                <MenuButtonAsMenuItem
                    key={`${option.content}-${option.value}`}
                    class={cssClass}
                    content={option.content}
                    value={option.value}
                    disabled={option.disabled}
                    checked={option.value === checkedValue}
                    onClick={handleItemClick}/>
            ))}
        </Submenu>
    );
}

const SingleSelectSubmenuAsMenuItem = withMenuItem(SingleSelectSubmenu);

export default SingleSelectSubmenu;
export { SingleSelectSubmenuAsMenuItem };
